<template>
  <b-container>
    <AccordionText
      v-for="accordion in accordions"
      :key="accordion.id"
      :id="accordion.id"
      :title="accordion.title"
      :text="accordion.text"
    ></AccordionText>
  </b-container>
</template>

<script>
import AccordionText from "../../components/AccordionText";

export default {
  data() {
    return {
      accordions: [
        {
          title: "Définition",
          id: "definition",
          text: `Lorsque les yeux fixent un objet de près, il faut qu’ils engagent les deux processus simultanément : l’accommodation (mise au point de la netteté) et la convergence (rapprochement des yeux). L’un et l’autre sont étroitement liés par le réflexe accommodation-convergence. 
L’insuffisance de convergence est une difficulté à maintenir la fixation rapprochée des deux yeux ensemble sur un objet situé en vision de près. 
Les troubles de l’accommodation sont des difficultés à faire la mise au point sur un objet en vision de près. Ils sont souvent dus à une hypermétropie latente ou à un défaut du lien entre l’accommodation et la convergence.
`
        },
        {
          title: "Symptômes",
          id: "symptome",
          text: `L'insuffisance de convergence et les troubles de l’accommodation peuvent être à l’origine de céphalées (maux de tête), de fatigue visuelle, de trouble de l’équilibre, de vision double, de vision floue, de mauvaise évaluation des distances... Ces gênes se manifestent le plus souvent lors d’un effort visuel important comme la lecture, la conduite, le travail sur écran.`
        },
        {
          title: "Traitement",
          id: "traitement",
          text: `Ces troubles sont mis en évidence lors du bilan orthoptique par le biais de différents tests, l’orthoptiste pourra alors vous proposer un équipement optique spécifique et/ou des séances de rééducation. Au besoin une orientation vers un autre spécialiste pourra être proposée (ophtalmologiste, ORL, opticien…)
Durant les séances de rééducation plusieurs exercices vous seront proposés selon vos difficultés et seront adaptés à votre évolution.
          ![Matériel de rééducation](/prisesEnChargeImages/image7.jpg)
          *Matériel de rééducation*
          `
        }
      ]
    };
  },
  components: {
    AccordionText
  }
};
</script>
